import createReducer from "../../reducers/createReducer";

import {
    GET_CONTACT_SUPPORT_LIST_ERROR,
    GET_CONTACT_SUPPORT_LIST_LOADING,
    GET_CONTACT_SUPPORT_LIST_SUCCESS,
    CREATE_CONTACT_SUPPORT_REQUEST_ERROR,
    CREATE_CONTACT_SUPPORT_REQUEST_LOADING,
    CREATE_CONTACT_SUPPORT_REQUEST_SUCCESS,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ERROR,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_LOADING,
    ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS
} from "./types";

const initialState = {
    loading: false,
    error: null,
    contactSupportList: [],
    contactSupport: null,
    successMessage: null
}

export const contactSupportReducer = createReducer(initialState, {
    [GET_CONTACT_SUPPORT_LIST_LOADING](state, action) {
        return Object.assign({}, state, {
            loading: true,
            error: null,
            contactSupportList: []
        })
    },
    [GET_CONTACT_SUPPORT_LIST_SUCCESS](state, action) {
        return Object.assign({}, state, {
            loading: false,
            error: null,
            contactSupportList: action.payload
        })
    },
    [GET_CONTACT_SUPPORT_LIST_ERROR](state, action) {
        return Object.assign({}, state, {
            loading: false,
            error: action.payload,
            contactSupportList: []
        })
    },
    [CREATE_CONTACT_SUPPORT_REQUEST_LOADING](state, action) {
        return Object.assign({}, state, {
            loading: true,
            error: null
        })
    },
    [CREATE_CONTACT_SUPPORT_REQUEST_SUCCESS](state, action) {
        return Object.assign({}, state, {
            loading: false,
            error: null
        })
    },
    [CREATE_CONTACT_SUPPORT_REQUEST_ERROR](state, action) {
        return Object.assign({}, state, {
            loading: false,
            error: action.payload
        })
    },
    [ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_ERROR](state, action) {
        return Object.assign({}, state, {
            loading: false,
            error: action.payload,
            successMessage: null
        })
    },
    [ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_LOADING](state, action) {
        return Object.assign({}, state, {
            loading: true,
            error: null,
            successMessage: null
        })
    },
    [ADD_CONTACT_SUPPORT_REQUEST_RESPONSE_SUCCESS](state, action) {
        return Object.assign({}, state, {
            loading: false,
            error: null,
            successMessage: action.payload
        })
    }
})